import React, { useState, useEffect, SetStateAction } from 'react';
import { ManagedModal, ModalContentArea, RadioGroup, SVGRadio } from '@riac/design-system';
import styled from 'styled-components';
import { RadioGroupAriaLabel } from '@riac/design-system/src/AriaControls/BaseComponents/Inputs';

const NotificationRadioGroup = styled(RadioGroup)`
    color: ${(props) => props.inverted ? 'black' : 'inherient'};
  flex-wrap: wrap;
    & ${RadioGroupAriaLabel} {
        flex-basis: 100%;
    }
`;

export default ({ inverted = true }):JSX.Element => {
  const [notificationOption, setNotificationOption] = useState<string>('');
  const [userMessage, setUserMessage] = useState<string>();

  const checkNotificationOption = async ():Promise<void> => {
    try {
      const result = await (await fetch('/api/account/info/outbid-notification', {
        credentials: 'include',
        method: 'GET',
      })).json();
      setNotificationOption(result.result);
    } catch (e) {
      console.log('notification options not found', e);
    }
  };

  useEffect(() => {
    checkNotificationOption().then();
  }, []);

  const handleOnChange = async (event: SetStateAction<string>):Promise<void> => {
    try {
      const result = await (await fetch('/api/account/info/outbid-notification', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify({ setting: event }),
      })).json();
      if(result.success) {
        setNotificationOption(event);
      } else {
        setUserMessage(result.result);
      }
    } catch (e) {
      console.log('Could not save notification', e);
    }
  };


  return (<>
    <NotificationRadioGroup
      direction={'row'}
      label="How would you like to receive outbid notifications?"
      onChange={handleOnChange}
      value={notificationOption}
      inverted={inverted}
    >
      <SVGRadio inverted={inverted} value={'email'}>Email</SVGRadio>
      <SVGRadio inverted={inverted} value={'text'}>Text Message</SVGRadio>
      <SVGRadio inverted={inverted} value={'both'}>Both</SVGRadio>
      <SVGRadio inverted={inverted} value={'none'}>None</SVGRadio>
    </NotificationRadioGroup>
    <ManagedModal
      title={'Notification settings'}
      isOpen={!!userMessage}
      isDismissable={true}
      showCloseButton={true}
      onClose={()=>setUserMessage(undefined)}
    >
      <ModalContentArea>
        {userMessage && <>
          {userMessage}
        </>}
      </ModalContentArea>
    </ManagedModal>
  </>
  );
};
